import { Box, Button, Paper, Typography, useTheme } from '@mui/material'
import { HomeOutlined, ArrowBackOutlined } from '@mui/icons-material'
import { useLocation, useNavigate } from 'react-router-dom'
import React from 'react'

import accessDeniedImg from '../assets/access-denied.svg'
import { useUserStore } from '../store/user.store'

const Unauthorized = () => {
    const { theme, layout } = useTheme()
    const navigate = useNavigate()
    const location = useLocation()

    const UserStore = useUserStore()

    // Get the path they tried to access from the router state
    const attemptedPath = location.pathname || "this page"

    const backToHome = () => {
        const layout = ["FACULTY", "HOD", "PRINCIPAL"].includes( UserStore.getUser.user_role ) ? "faculty" : "student"
        navigate( `/${layout}/home` )
    }

    return (
        <Box
            sx={{
                background: `url('/imgs/bg-pattern1.png')`,
                flexGrow: 1,
                width: "100vw"
            }}
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            {/* Dark mode overlay */}
            {theme === 'dark' && (
                <Box sx={{
                    zIndex: 1,
                    background: "rgba(0,0,0,0.8)",
                    position: "absolute",
                    inset: 0
                }} />
            )}

            <Paper
                elevation={3}
                sx={{
                    zIndex: 10,
                    padding: "40px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    maxWidth: "450px",
                    gap: "20px",
                    borderRadius: "12px"
                }}
            >
                {/* Image Placeholder */}
                <Box
                    component="img"
                    src={accessDeniedImg}
                    alt="Access Denied"
                    sx={{ width: "200px", height: "auto", mb: 2 }}
                />

                <Box>
                    <Typography variant="h5" fontWeight="700" color="error" gutterBottom>
                        Access Denied
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        You do not have the necessary permissions to view
                        <strong style={{ color: theme === 'dark' ? '#fff' : '#000' }}> {attemptedPath}</strong>.
                        Please contact support if you believe this is an error.
                    </Typography>
                </Box>

                <Box display="flex" gap="15px" width="100%" justifyContent="center" mt={1}>
                    <Button
                        variant="outlined"
                        startIcon={<ArrowBackOutlined />}
                        onClick={() => navigate( -1 )}
                        sx={{ textTransform: 'none' }}
                    >
                        Go Back
                    </Button>
                    <Button
                        variant="contained"
                        disableElevation
                        startIcon={<HomeOutlined />}
                        onClick={backToHome}
                        sx={{ textTransform: 'none' }}
                    >
                        Back to Home
                    </Button>
                </Box>
            </Paper>
        </Box>
    )
}

export default Unauthorized